import axios from '@/utils/axiosHelper';

// 初始化前授权
export const onGetOpenAPI = (params) => {
  return axios({ url: '/wechat/get/open', method: 'GET', params }, { interceptResultCode: false });
};

// codeId查询api
export const wechatInfoAPI = (params) => {
  return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false });
};

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/sword/open/service/init', method: 'GET', params }, { interceptResultCode: false });
};

// 支付api
export const paymentApi = (params) => {
  return axios({ url: '/sword/open/service/pay', method: 'POST', params }, { interceptResultCode: false });
};

// 新支付api(v2)
export const paymentApiV2 = (params) => {
  return axios({ url: '/sword/open/service/pay/v2', method: 'POST', params }, { interceptResultCode: false });
};

// 支付订单查询
export const wxPaymentApi = (params) => {
  return axios({ url: '/sword/open/service/pay/show', method: 'POST', params }, { interceptResultCode: false });
};

// 领取金龙（积分）api
export const integralApi = (params) => {
  return axios({ url: '/sword/open/service/get/scrip', method: 'POST', params }, { interceptResultCode: false });
};

// 签到按钮api
export const clockInApi = (params) => {
  return axios({ url: '/sword/open/service/sign', method: 'POST', params }, { interceptResultCode: false });
};

// 新签到按钮api(v2)
export const clockInApiV2 = (params) => {
  return axios({ url: '/sword/open/service/sign/v2', method: 'POST', params }, { interceptResultCode: false });
};

// 获取uuid-api
export const getUuidApi = (params) => {
  return axios({ url: '/sword/open/service/identification', method: 'GET', params }, { interceptResultCode: false });
};

// 记录uuid使用情况api
export const getUseUuidApi = (params) => {
  return axios({ url: '/sword/open/service/use', method: 'GET', params }, { interceptResultCode: false });
};

// 退款api
export const getRefundApi = (params) => {
  return axios({ url: '/sword/open/service/refund', method: 'GET', params }, { interceptResultCode: false });
};

// 新退款api(v2)
export const getRefundApiV2 = (params) => {
  return axios({ url: '/sword/open/service/refund/v2', method: 'GET', params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/hjwq/kfhd2/api.js